import { useState } from 'react'
import api from '../../utils/api'
import useToastContext from '../useToastContext'
import { notificationTypes } from '../../contexts/toastContext'

const useReservationsApi = () => {
  const addToast = useToastContext()

  const [reservationsState, setReservationsState] = useState({
    reservations: [],
    pagination: null,
    isLoading: false,
    error: null,
  })

  const [cancelState, setCancelState] = useState({ isLoading: false, error: null })

  async function getReservations(params = {}) {
    try {
      setReservationsState((current) => ({ ...current, isLoading: true, error: null }))
      const response = await api.get('/reservations', { params, includeToken: true })
      setReservationsState({
        reservations: response.data?.data || [],
        pagination: response.data?.pagination || null,
        isLoading: false,
        error: null,
      })
      return response.data
    } catch (error) {
      setReservationsState((current) => ({
        ...current,
        isLoading: false,
        error: error.response?.data?.message || 'Error al obtener reservas',
      }))
      addToast(
        notificationTypes.error,
        error.response?.data?.message || 'Error al obtener reservas'
      )
    }
  }

  async function cancelReservation(id, reason) {
    try {
      setCancelState({ isLoading: true, error: null })
      await api.post(
        `/reservations/${id}/cancel`,
        { reason: reason || null },
        { includeToken: true }
      )
      setCancelState({ isLoading: false, error: null })
      addToast(notificationTypes.success, 'Reserva cancelada')
    } catch (error) {
      setCancelState({
        isLoading: false,
        error: error.response?.data?.message || 'Error al cancelar reserva',
      })
      addToast(
        notificationTypes.error,
        error.response?.data?.message || 'Error al cancelar reserva'
      )
      throw error
    }
  }

  const state = { reservationsState, cancelState }
  const methods = { getReservations, cancelReservation }

  return [state, methods]
}

export default useReservationsApi
